import React from 'react';

export const LoginSignupContext = React.createContext({
  ctaColor: '#d3277e', // $ol-colours-cta-pink
});
